import axios from 'axios';

const actionTypes = {
    GET_INVOICES_REQUEST: 'GET_INVOICES_REQUEST',
    GET_INVOICES_RESPONSE: 'GET_INVOICES_RESPONSE',
    GET_INVOICE_AMOUNTS: 'GET_INVOICE_AMOUNTS',
    SET_SELECTED_INVOICES: 'SET_SELECTED_INVOICES',
    OPEN_INVOICE_MODAL: 'OPEN_INVOICE_MODAL',
    OPEN_DOCUMENTS_MODAL_REQUEST: 'OPEN_DOCUMENTS_MODAL_REQUEST',
    OPEN_DOCUMENTS_MODAL_RESPONSE: 'OPEN_DOCUMENTS_MODAL_RESPONSE',
    CLOSE_MODAL: 'CLOSE_MODAL',
    PAY_MODAL_ACTIVE: 'PAY_MODAL_ACTIVE'
};

export const getInvoices = (activeTab, pageIndex, maxRows, searchTerm) => async (dispatch, getState) => {
    const requestAction = {
        type: actionTypes.GET_INVOICES_REQUEST
    };

    dispatch(requestAction);
    axios(`api/Invoice/GetInvoices?activeTab=${activeTab}&pageIndex=${pageIndex}&maxRows=${maxRows}&searchTerm=${searchTerm}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    }).then(response => {
        if (response.status === 200) {

            var counts = getState().accountingData.counts;
            if (counts) {
                counts[activeTab] = response.data.invoiceCount;
            }
            const responseAction = {
                type: actionTypes.GET_INVOICES_RESPONSE,
                payload: {
                    list: response.data.invoiceList,
                    invoicesTab: activeTab,
                    invoicesPageIndex: pageIndex,
                    showingMax: maxRows,
                    customerId: response.data.customerId,
                    searchText: searchTerm,
                    counts: counts
                }
            };
            dispatch(responseAction);
        }
    });
};

export const getInvoiceAmounts = () => (dispatch, getState) => {
    axios('api/Invoice/GetInvoiceAmounts', {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    }).then(response => {
        if (response.status == 200) {
            const action = {
                type: actionTypes.GET_INVOICE_AMOUNTS,
                payload: {
                    counts: response.data.counts.value,
                    totalAmounts: response.data.totalAmounts.value
                }
            };

            dispatch(action);
        }
    });
};

export const setSelectedInvoices = (numbers, amount) => dispatch => {
    const action = {
        type: actionTypes.SET_SELECTED_INVOICES,
        payload: {
            amount,
            numbers: [...numbers]
        }
    };

    dispatch(action);
};

export const openInvoiceModal = (invoiceNumber, isPdf) => (dispatch, getState) => {
    fetch('api/App/GetDevMinaylaUrl', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    })
        .then(response => response.json())
        .then(response => {
            const pdfParam = isPdf ? '/?notpdf=OK' : '';
            const url = `${response.devUrl}App/Invoice/Attachment/${invoiceNumber}${pdfParam}`;

            const action = {
                type: actionTypes.OPEN_INVOICE_MODAL,
                payload: url
            };

            dispatch(action);
        });
};

export const closeModal = () => dispatch => {
    dispatch({
        type: actionTypes.CLOSE_MODAL
    });
};

export const openDocumentsModal = invoiceNumber => (dispatch, getState) => {
    dispatch({ type: actionTypes.OPEN_DOCUMENTS_MODAL_REQUEST });

    axios({
        method: 'post',
        url: 'api/Factoring/factoringinvoicedocuments',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        },
        data: invoiceNumber
    })
        .then(response => {
            fetch('api/App/GetDevMinaylaUrl', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + getState().account.user.token
                }
            })
                .then(fetched => fetched.json())
                .then(fetched => {
                    let action = {
                        type: actionTypes.OPEN_DOCUMENTS_MODAL_RESPONSE,
                        payload: null
                    };

                    const docs = response.data.invoiceDocuments;
                    if (docs && docs.length) {
                        action.payload = docs.map(doc => {
                            return {
                                url: fetched.devUrl + 'app/api/v1/dispatching/retrievepod/' + doc.docId,
                                name: doc.fileName
                            }
                        });
                    }
                    dispatch(action);
                });
        });
}


export const PayButtonActive = () => (dispatch, getState) => {

    const responseAction = {
        type: actionTypes.PAY_MODAL_ACTIVE,
        payload: {
            payButtonDisable: false
        }
    }

    dispatch(responseAction);
}


// WEBPACK FOOTER //
// ./src/actions/AccountingActions.js